// extracted by mini-css-extract-plugin
module.exports = {"container":"_f6b45b5","loader":"_4a1f1c6"};